import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '@/views/login/index'
import Layout from '@/layout/index.vue'
let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
let RoleName = null
if (userInfo) {
    RoleName = userInfo.roleCode ? userInfo.roleCode : null
}

const routes = [
    { path: '/login', component: Login, name: 'login', hidden: true },
    // {
    //     path: '/',
    //     //  需要重定向 首页之类的展示页面
    //     redirect: '/'
    // },
    {
        path: '/',
        name: 'enterprise',
        redirect: '/',
        meta: {
            title: '企业管理',
            icon: 'building-line',
            roles: ['ROLE_TUV_ADMIN'],
            isRouteBool: false, //判断是否展示多个菜单
        },
        hidden: false,
        component: Layout,
        children: [{
                path: '/',
                name: 'enterpriseList',
                component: () =>
                    import ("@/views/enterprise/index.vue"),
                meta: {
                    title: '企业管理列表',
                    icon: '',
                    roles: ['ROLE_TUV_ADMIN'],
                    affix: true,
                },
                hidden: true,
            },
            {
                path: '/enterprise/detail',
                name: 'enterpriseDetail',
                component: () =>
                    import ("@/views/enterprise/detail.vue"),
                meta: {
                    title: '企业详情',
                    icon: '',
                    roles: ['ROLE_TUV_ADMIN'],
                    affix: true,
                },
                hidden: true,
            },
            {
                path: '/enterprise/orderDetails',
                name: 'orderDetails',
                component: () =>
                    import ("@/views/enterprise/orderDetails.vue"),
                meta: {
                    title: '企业订单',
                    icon: '',
                    roles: ['ROLE_TUV_ADMIN'],
                    affix: true,
                },
                hidden: true,
            },
        ]
    },

    {
        path: '/account',
        name: 'account',
        redirect: '/account',
        meta: {
            title: '账号管理',
            icon: 'share-line',
            roles: ['ROLE_TUV_ADMIN'],
            isRouteBool: false, //判断是否展示多个菜单
        },
        // hidden: false,
        hidden: RoleName == 'ROLE_COMPANY_PROVIDER',
        alwaysShow: true,
        component: Layout,
        children: [{
                path: '/account',
                name: 'accountList',
                component: () =>
                    import ("@/views/account/index.vue"),
                meta: {
                    title: '账号列表',
                    icon: '',
                    roles: ['ROLE_TUV_ADMIN'],
                    affix: true,
                },
                hidden: true,
            },
            {
                path: '/account/detail',
                name: 'accountDetail',
                component: () =>
                    import ("@/views/account/detail.vue"),
                meta: {
                    title: '新建账号',
                    icon: '',
                    roles: ['ROLE_TUV_ADMIN'],
                    affix: true,
                },
                hidden: true,
            },
        ]
    },

    {
        path: '/stand/',
        name: 'stand',
        redirect: '/stand/',
        meta: {
            title: '联系我们',
            icon: 'message-2-line',
            roles: ['ROLE_TUV_ADMIN', 'ROLE_TUV_ENGINEER'],
            isRouteBool: false, //判断是否展示多个菜单
        },
        hidden: false,
        alwaysShow: true,
        component: Layout,
        children: [{
            path: '/stand/',
            name: 'standList',
            component: () =>
                import ("@/views/Message/index.vue"),
            meta: {
                title: '消息列表',
                icon: '',
                roles: ['ROLE_TUV_ADMIN', 'ROLE_TUV_ENGINEER'],
                affix: true,
                type: 1,
            },
            hidden: true,
        }, ]
    },
    {
        path: '/personal/',
        name: 'Personal',
        redirect: '/personal/',
        meta: {
            title: '个人中心',
            icon: 'user-3-line',
            roles: ['ROLE_TUV_ADMIN', 'ROLE_TUV_ENGINEER'],
            isRouteBool: false, //判断是否展示多个菜单
        },
        hidden: false,
        alwaysShow: true,
        component: Layout,
        children: [{
            path: '/personal/',
            name: 'personalDetail',
            component: () =>
                import ("@/views/personal/index.vue"),
            meta: {
                title: '',
                icon: '',
                roles: ['ROLE_TUV_ADMIN', 'ROLE_TUV_ENGINEER'],
                affix: true,
                type: 1,
            },
            hidden: true,
        }, ]
    },






]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router

//路由拦截
router.beforeEach((to, from, next) => {
    //如果访问的是登录页面，直接放行
    if (to.path === '/login') {
        return next()
    }
    //如果访问的是有登陆权限的页面，先要获取登录信息
    const token = window.sessionStorage.getItem('token')
        //如果登录信息不存在，强制跳转登录页面，否则放行
    if (!token) {
        return next('/login')
    }
    next()
})
router.afterEach(((to, from) => {
    if (from.path == '/login') {
        window.location.reload();
    }
}))